<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import CompanySortMenu from './components/CompanySortMenu.vue';
import CompanyMoreActions from './components/CompanyMoreActions.vue';

defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['search', 'update:sort', 'create']);
</script>

<template>
  <header class="sticky top-0 z-20 px-6 bg-n-background">
    <div class="flex flex-col w-full gap-3 pt-6 pb-4 mx-auto max-w-5xl">
      <div
        class="flex items-start justify-between w-full gap-2 sm:items-center"
      >
        <span
          class="text-xl font-semibold tracking-[-0.02em] truncate text-n-slate-12"
        >
          {{ headerTitle }}
        </span>
        <div class="flex items-center flex-shrink-0 gap-2">
          <CompanySortMenu
            :active-sort="activeSort"
            :active-ordering="activeOrdering"
            @update:sort="emit('update:sort', $event)"
          />
          <CompanyMoreActions @create="emit('create')" />
          <Button
            :label="$t('COMPANIES.ACTIONS.CREATE')"
            icon="i-lucide-plus"
            size="sm"
            class="!h-[38px] rounded-lg !text-[13px] font-semibold !bg-n-blue-9 hover:enabled:!bg-n-blue-10 !text-white ltr:ml-1 rtl:mr-1"
            @click="emit('create')"
          />
        </div>
      </div>
      <div v-if="showSearch" class="flex items-center w-full gap-2.5">
        <Input
          :model-value="searchValue"
          type="search"
          :placeholder="$t('COMPANIES.SEARCH_PLACEHOLDER')"
          :custom-input-class="[
            'h-10 !bg-n-solid-1 rounded-lg !text-[13.5px] ltr:!pl-9 rtl:!pr-9',
          ]"
          class="w-full sm:max-w-[420px]"
          @input="emit('search', $event.target.value)"
        >
          <template #prefix>
            <Icon
              icon="i-lucide-search"
              class="absolute -translate-y-1/2 text-n-slate-10 size-4 top-1/2 ltr:left-3 rtl:right-3"
            />
          </template>
        </Input>
      </div>
    </div>
  </header>
</template>
